import React, { useState, FC } from "react";
import { Button } from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "../../inputs/ByzMuiTypography";
import EditIcon from '@mui/icons-material/Edit';

interface ByzMuiDeleteButtonProps extends React.ComponentProps<typeof Button> {
  onClick?: () => void;
  link?: string;
  popup?: boolean;
}

const StyledButton = styled(Button)<{ popup?: boolean }>(
  ({ popup, disabled, theme }) => ({
    borderRadius: popup ? "20px" : "4px",
    padding: "4px 20px",
    gap: "4px",
    textTransform: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${disabled ? theme.palette.action.disabled : theme.palette.primary.main}`,
    backgroundColor: disabled
      ? alpha(theme.palette.action.disabled, 0.2)
      : alpha(theme.palette.primary.main, 0.1),
    color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
    cursor: disabled ? 'not-allowed' : 'pointer',
    "&:hover": {
      backgroundColor: disabled ? undefined : theme.palette.primary.main,
      color: disabled ? undefined : theme.palette.common.white,
    },
  })
);

const ByzMuiDeleteButton: FC<ByzMuiDeleteButtonProps> = ({
  onClick,
  link,
  popup,
  disabled,
  children,
  ...rest
}) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  const btn = (
    <StyledButton
      popup={popup}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...rest}
    >
      <EditIcon />
      <ByzMuiTypography fontWeight={400} variant="body2" sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {children || t("buttons.edit")}
      </ByzMuiTypography>
    </StyledButton>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: "none" }}>{btn}</Link>
  ) : (
    btn
  );
};

export default ByzMuiDeleteButton;